import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HistList } from "../service/Model/HistList";
import { HistlistService } from "../service/histlist.service";
import { MpHistoryService } from "../service/mp.history.service";
import { CsvExport, Property2ReadableName } from "../../../config/globals/csvExport.global";
import { CsvData } from "../service/Model/CsvData";
import { FileExtension } from "./types/FileExtension";
import { DatePipe } from "@angular/common";

@Component({
  selector: 'app-maklerpaket-kraft-hist-list',
  templateUrl: './app.maklerpaket.kraft.hist.list.html',
  styleUrls: ['./app.maklerpaket.kraft.hist.list.scss'],
})
export class AppMaklerpaketKraftHistList implements OnInit{

  histList : HistList[] = [];

  private readonly FileExtension = FileExtension;  // need to be able use enum in corresponding html component

  @Input()
  id_origin : any;
  @Output()
  showHistList: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(private HistListService: HistlistService, private mpHistory: MpHistoryService) {
  }

  ngOnInit() {
    console.log("Beim initialisieren... " + this.id_origin);

    this.HistListService.loadHistList(this.id_origin).subscribe( (histListAusDB) => {
      this.histList = histListAusDB;
      console.log("Historien aus DB gelesen");
    }, (error) => {
      this.errorHandling(error);
    });
  }

  hideHistList() {
    this.showHistList.emit(false);
  }

  private errorHandling(error) {
    console.log(error);
  }

  exportMaklerPaketHistory(id: string, fileName2Export: string, changeTime: string, fileFormat: FileExtension = FileExtension.CSV) {
    this.mpHistory.loadMpHistById(parseInt(id)).subscribe( (historicData) => {
      let exportData = historicData.csv_data;
      let exportDataInObjectForm = this.convertData2ObjectForm(exportData);
      let exportFileName = AppMaklerpaketKraftHistList.buildExportFileName(fileName2Export, changeTime, fileFormat);

      new CsvExport().downloadAsCSV(exportDataInObjectForm, AppMaklerpaketKraftHistList.dataMapping2Object, exportFileName);
    }, (error) => {
      this.errorHandling(error);
      throw new Error("Error by file export in " + fileFormat + " format");
    });

  }

  private static buildExportFileName(teilpaketName: string, changeTime: string, fileExtension: FileExtension): string {
    let fileName2Export = teilpaketName + "_" + new DatePipe('de-DE').transform(new Date(changeTime), 'dd-MM-yyyyTHH:mm:ss', null, 'de-DE');

    switch (fileExtension) {
      case FileExtension.CSV:
        return fileName2Export + '.' + FileExtension.CSV;
      case FileExtension.TEXT:
        return fileName2Export + '.' + FileExtension.TEXT;
      default:
        throw new Error("File extension not yet supported");
    }
  }

  private static dataMapping2Object: Property2ReadableName[] = [

    {propertyName: "status", readableName: "Status"},
    {propertyName: "vorgangsnummerVM", readableName: "Vorgangsnummer_VM"},
    {propertyName: "anredeVN", readableName: "Anrede VN"},
    {propertyName: "nameVN", readableName: "Name VN"},
    {propertyName: "vornameVN", readableName: "Vorname VN"},
    {propertyName: "geburtsdatumVN", readableName: "Geburtsdatum VN"},
    {propertyName: "postleitzahlVN", readableName: "Postleitzahl VN"},
    {propertyName: "wohnortVN", readableName: "Wohnort VN"},
    {propertyName: "strasseVN", readableName: "Strasse VN"},
    {propertyName: "hausnummerVN", readableName: "Hausnummer VN"},
    {propertyName: "eMailVN", readableName: "E-Mail VN"},
    {propertyName: "telefonVN", readableName: "Telefon VN"},
    {propertyName: "zahlungsweise", readableName: "Zahlungsweise"},
    {propertyName: "zahlungsart", readableName: "Zahlungsart"},
    {propertyName: "abweichenderBeitragszahler", readableName: "Abweichender Beitragszahler"},
    {propertyName: "bankverbindungIBAN", readableName: "Bankverbindung IBAN"},
    {propertyName: "vorsteuerabzugsberechtigungVN", readableName: "Vorsteuerabzugsberechtigung VN"},
    {propertyName: "rechtsformVN", readableName: "Rechtsform VN"},
    {propertyName: "abweichenderHalter", readableName: "Abweichender Halter"},
    {propertyName: "anredeHalter", readableName: "Anrede Halter"},
    {propertyName: "nameHalter", readableName: "Name Halter"},
    {propertyName: "vornameHalter", readableName: "Vorname Halter"},
    {propertyName: "geburtsdatumHalter", readableName: "Geburtsdatum Halter"},
    {propertyName: "postleitzahlHalter", readableName: "Postleitzahl Halter"},
    {propertyName: "wohnortHalter", readableName: "Wohnort Halter"},
    {propertyName: "strasseHalter", readableName: "Strasse Halter"},
    {propertyName: "hausnummerHalter", readableName: "Hausnummer Halter"},
    {propertyName: "rechtsformHalter", readableName: "Rechtsform Halter"},
    {propertyName: "anredeBeitragszahler", readableName: "Anrede Beitragszahler"},
    {propertyName: "nameBeitragszahler", readableName: "Name Beitragszahler"},
    {propertyName: "vornameBeitragszahler", readableName: "Vorname Beitragszahler"},
    {propertyName: "geburtsdatumBeitragszahler", readableName: "Geburtsdatum Beitragszahler"},
    {propertyName: "postleitzahlBeitragszahler", readableName: "Postleitzahl Beitragszahler"},
    {propertyName: "ortBeitragszahler", readableName: "Ort Beitragszahler"},
    {propertyName: "strasseBeitragszahler", readableName: "Strasse Beitragszahler"},
    {propertyName: "hausnummerBeitragszahler", readableName: "Hausnummer Beitragszahler"},
    {propertyName: "beginn", readableName: "Beginn"},
    {propertyName: "ende", readableName: "Ende"},
    {propertyName: "gewuenschterVersicherungsschutz", readableName: "Gewünschter Versicherungsschutz"},
    {propertyName: "sFKlasseHaftpflicht", readableName: "SFKlasse Haftpflicht"},
    {propertyName: "selbstbeteiligungTeilkasko", readableName: "Selbstbeteiligung Teilkasko"},
    {propertyName: "sFKlasseVollkasko", readableName: "SFKlasse Vollkasko"},
    {propertyName: "selbstbeteiligungVollkasko", readableName: "Selbstbeteiligung Vollkasko"},
    {propertyName: "schutzbrief", readableName: "Schutzbrief"},
    {propertyName: "auslandsschadenschutz", readableName: "Auslandsschadenschutz"},
    {propertyName: "fahrerPlusFahrerSchutz", readableName: "FahrerPlus-FahrerSchutz"},
    {propertyName: "rabattschutz", readableName: "Rabattschutz"},
    {propertyName: "autoNotruf", readableName: "AutoNotruf"},
    {propertyName: "bonusDrive", readableName: "BonusDrive"},
    {propertyName: "beitragsschutz", readableName: "Beitragsschutz"},
    {propertyName: "werkstattBonus", readableName: "WerkstattBonus"},
    {propertyName: "werterhaltGarantie", readableName: "WerterhaltGarantie"},
    {propertyName: "eigentumsverhaeltnisZumFahrzeug", readableName: "Eigentumsverhaeltnis zum Fahrzeug"},
    {propertyName: "erstzulassungDesFahrzeuges", readableName: "Erstzulassung des Fahrzeuges"},
    {propertyName: "ersteZulassungAufDenVNHalter", readableName: "Erste Zulassung auf den VN / Halter"},
    {propertyName: "fahrzeugidentifizierungsnummer", readableName: "Fahrzeugidentifizierungsnummer"},
    {propertyName: "herstellerschluessel", readableName: "Herstellerschluessel"},
    {propertyName: "typschluessel", readableName: "Typschluessel"},
    {propertyName: "wagniskennziffer", readableName: "Wagniskennziffer"},
    {propertyName: "amtlichesKennzeichen", readableName: "Amtliches Kennzeichen"},
    {propertyName: "saisonkennzeichen", readableName: "Saisonkennzeichen"},
    {propertyName: "betriebszeitraumVonMonat", readableName: "Betriebszeitraum von (Monat)"},
    {propertyName: "betriebszeitraumBisMonat", readableName: "Betriebszeitraum bis (Monat)"},
    {propertyName: "betriebsausgabe", readableName: "Betriebsausgabe"},
    {propertyName: "beitragVorVUGesamt", readableName: "Beitrag VorVU Gesamt"},
    {propertyName: "beitragVorVUKH", readableName: "Beitrag VorVU KH"},
    {propertyName: "beitragVorVUKasko", readableName: "Beitrag VorVU Kasko"},
    {propertyName: "beitragVorVUSonstiges", readableName: "Beitrag VorVU Sonstiges"},
    {propertyName: "beitragVorVUInsassenUnfall", readableName: "Beitrag VorVU Insassen-Unfall"},
    {propertyName: "vorVUNrGDVNr", readableName: "VorVU-Nr. (GDV-Nr.)"},
    {propertyName: "amtlichesKennzeichenDerVorversicherung", readableName: "Amtliches Kennzeichen der Vorversicherung"},
    {propertyName: "saisonkennzeichenDerVorversicherung", readableName: "Saisonkennzeichen der Vorversicherung"},
    {propertyName: "versicherungsscheinnummerDerVorversicherung", readableName: "Versicherungsscheinnummer der Vorversicherung"},
    {propertyName: "hinweis", readableName: "HINWEIS"},
    {propertyName: "deckungKH", readableName: "Deckung KH"},
    {propertyName: "produktlinie", readableName: "Produktlinie"},
    {propertyName: "bemerkung", readableName: "BEMERKUNG"},
    {propertyName: "aZBeitragGesamt", readableName: "AZ Beitrag Gesamt"},
    {propertyName: "aZBeitragKH", readableName: "AZ Beitrag KH"},
    {propertyName: "aZBeitragKasko", readableName: "AZ Beitrag Kasko"},
    {propertyName: "nachlassZuschlagGesamt", readableName: "Nachlass/Zuschlag Gesamt"},
    {propertyName: "nachlassZuschlagKH", readableName: "Nachlass/Zuschlag KH"},
    {propertyName: "nachlassZuschlagKasko", readableName: "Nachlass/Zuschlag Kasko"}
  ];

  private convertData2ObjectForm(inputData: object[]): CsvData[] {
    let convertedData: CsvData[] = Array<CsvData>();

    Object.values(inputData).map(arrayItem => {
      let csvData: CsvData = new CsvData();
      AppMaklerpaketKraftHistList.dataMapping2Object.map(propertyMapping => {
        if (undefined != arrayItem[propertyMapping.readableName]) {
          csvData[propertyMapping.propertyName] = arrayItem[propertyMapping.readableName];
        }
      });
      convertedData.push(csvData);
    });

    return convertedData;
  }


}
